export class ProductUpdateHistory {
  public date: Date;
  public name: string;
  public oldVersion: string;
  public newVersion: string;
}
